import React from "react";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import OrderDTO from "@/dto/order/OrderDTO";
import ShopType from "@/enum/ShopType";
import OrderStatus from "@/enum/OrderStatus";
import { select } from "@/utils/dom";
import OrderOriginalId from "../../../../../../components/OrderOriginalId";
import copy from "copy-to-clipboard";
import { message } from "antd";

interface OriginalIdColumnProps {
    order?: OrderDTO;

    shopType?: ShopType;
}

const OriginalIdColumn: React.FC<OriginalIdColumnProps> = function (props) {
    const order = props.order;
    const shopType = props.shopType;

    const info = order.retailerDropShippingInfo;

    const isSubmitDropShipping = !!info && info?.orderStatus !== OrderStatus.CANCELED;

    const textStyle: React.CSSProperties = isSubmitDropShipping ? { textDecoration: "line-through" } : undefined;

    const id = `order-original-id-column-${order.id}`;

    const handleCopy = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();

        const el = document.getElementById(id);

        select(el);

        let text = el.textContent
            .split("\r\n")
            .filter((it) => !!it)
            .join(",");

        copy(text);

        message.success("复制成功");
    };

    if (order.mergeSplitStatus === OrderMergeSplitStatus.MERGE_PARENT && order.childOrders) {
        return (
            <td>
                <div id={id}>
                    {order.childOrders.map((childOrder) => {
                        return (
                            <p key={childOrder.originalId} style={textStyle} id={childOrder.originalId}>
                                <OrderOriginalId order={childOrder} shopType={shopType} />
                            </p>
                        );
                    })}
                </div>

                <a href="#" className="small text-light link-btn" onClick={handleCopy}>
                    复制
                </a>
            </td>
        );
    }

    return (
        <td>
            <p id={id} style={textStyle}>
                <OrderOriginalId order={order} shopType={shopType} />
            </p>

            <a href="#" className="small text-light link-btn" onClick={handleCopy}>
                复制
            </a>
        </td>
    );
};

export default React.memo(OriginalIdColumn);
